module.exports = __webpack_public_path__ + "static/project5-95cc3df92fe29e6bcb473e0b2596b855.jpg";